module.exports = {
    // publicPath: '/gamotions/dist', // use this public path only for stagging build

    chainWebpack: config => {
    config.performance
      .maxEntrypointSize(512000)
      .maxAssetSize(512000)
  }
}
